import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=0efc910d&"
import script from "./InputItem.vue?vue&type=script&lang=ts&"
export * from "./InputItem.vue?vue&type=script&lang=ts&"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=0efc910d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports